import { render, staticRenderFns } from "./SupportSound.vue?vue&type=template&id=3c9487fc&scoped=true&"
import script from "./SupportSound.vue?vue&type=script&lang=js&"
export * from "./SupportSound.vue?vue&type=script&lang=js&"
import style0 from "./SupportSound.vue?vue&type=style&index=0&id=3c9487fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9487fc",
  null
  
)

export default component.exports